export class ProviderType {
  name: string;
  checked: boolean;
  disabled: boolean;
  visible: boolean = true;
}

export class MessageTypeGrouping {
  messagePreferences: MessagePreference[];
  category: string;
  visible: boolean = true;
}

export class MessagePreference {
  messageName: string;
  providerTypes: ProviderType[];
}

export class UserMessagePreference {
  userId: string;
  messageTypeGroupings: MessageTypeGrouping[];
}

export class SaveMessagePreference {
  messageName: string;
  checkedProviderTypes: string[];
  notCheckedProviderTypes: string[];
}

export class SaveUserPreference {
  userId: string;
  messagePreferences: SaveMessagePreference[];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/notification/model.ts